export const APP_NAME = "OGESTYLE";
export const APP_LOGO_URL = "/ogestyle-logo.png";
export const APP_FOOTER_LOGO_URL = "/ogestyle-logo-footer.png";
